<template>
  <div>
    <CRUDList
        ref="crudList"
        :canAdd="false"
        :canEdit="true"
        :canSave="false"
        :showSelect="false"
        :showDate="true"
        :showTotal="true"
        :enableFixedHeaders="true"
        :useSelectedItemsStore="true"
        :displayTopPagination="false"
        :hideDefaultFooter="false"
        :disablePagination="false"
        :loadingData="loading"
        :headers="headers"
        :baseCrudKey="baseCrudKey"
        :dialogHeaderName="dialogHeaderName"
        :defaultSortBy="defaultSortBy"
        :footerTotalDisplayColumnWise="footerTotals()"
        tableWrapperDynamicClassname='elevation-3 ma-3 pa-1 taxroll-table-wrapper'
        tableDynamicClassname='taxroll-custom-table'
        tableDynamicHeight='200'
        :variableToChangeRowBgColor="[{ varName: 'itsNewRecord', varCol: '#add8e6' }]"
        @loadCRUDList="handleLoadCRUDList"
      >
      <!-- :variableToChangeRowBgColor="[{ varName: 'itsNewRecord', varCol: '#add8e6' }]": this is added when there is new record added, the used can identify it -->
          <template v-slot:[`editedItem`]="{}">
            <TaxEditDialog
              :baseCrudKey="baseCrudKey"
              :halfPaymentFlag="halfPaymentFlag"
              @dataChanged="handleTaxDetailChanged"
              @delete="handleTaxDetailDeleted" />
          </template>

          <template v-slot:addidtionalCrudFooter>
            <div class="d-flex justify-center" style="width: 100%;">
              <v-btn class="mt-2 glow-on-for-add-all-unpaids"
                absolutecolor="primary" small @click="addComments">Add Comment</v-btn>
            </div>
          </template>

    </CRUDList>

    <!-- Add Tax Details Section - For adding new items only -->
    <v-card class="ma-1">
      <div class="text-subtitle-1 pa-1 pb-0">
        <div class="d-flex justify-space-between align-center" style="width: 100%;">
          <div>
            <v-icon left small>mdi-plus-circle</v-icon>
            Add Tax Details to Payment
          </div>
          <!-- Add to List is now committed automatically - by the Payment Info fields
               (paymentFieldActivity) and once an unpaids / parcel load finishes
               (unpaidTaxesAdded) - so the clerk no longer has to click it.
          <v-btn
            x-small
            color="primary"
            @click="addToList"
            :disabled="!hasValidItemsToAdd"
            class="mr-2"
          >
            <v-icon left x-small>mdi-check</v-icon>
            Add to List
          </v-btn>
          -->

        </div>
      </div>
      <div class="pa-0 pt-0">
        <dialogTaxDetails
          ref="dialogTaxDetailsRef"
          v-model="newTaxDetailsToAdd"
          :baseCrudKey="addTaxCrudKey"
          :fiscalYear="editedItem.fiscalYear"
          :loadMoreTaxBtn="false"
          :isItFromLargePayments="true"
          @unpaidTaxesAdded="commitStagedTaxRows"
          @commitStagedTaxRows="commitStagedTaxRows" />
      </div>
    </v-card>
    <v-dialog v-model="commentDialog" max-width="600" class="input-text-size">
      <v-card>
        <v-card-title class="input-text-size">Add Comments</v-card-title>
        <v-card-text class="input-text-size">
          <v-container>
            <v-row>
              <v-col cols="6" class="mt-n3">
                  <CommonDropDowns v-if="commentDialog"
                   :isItCategory=true @change="dataFromCommonDropDowns"
          :commentsCategoryValue="commentData.category" :isCommentsCategoryDisabled="true" />
              </v-col>
               <v-col cols="6" class="pt-2 pb-0 mb-n4 mt-n2">
        <v-autocomplete :items="reasonListDropDown" class="input-text-size" label='Reason Code'
         v-model="commentData.reasonCode" item-text="name" item-value="value" />
      </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <v-checkbox
                  v-model="commentData.addToLegal"
                  label="Add To Legal on Statement"
                  dense
                  hide-details
                  class="input-text-size"
                />
              </v-col>
              <v-col cols="4">
                <v-checkbox
                  v-model="commentData.sendToWebsite"
                  label="Send To Website"
                  dense
                  hide-details
                  class="input-text-size"
                />
              </v-col>
              <v-col cols="4">
                <v-checkbox
                  v-model="commentData.rollToNextYear"
                  label="Roll To Next Year"
                  dense
                  hide-details
                  class="input-text-size"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="commentData.comment"
                  label="Comments"
                  rows="4"
                  dense
                  outlined
                  hide-details
                  class="input-text-size"
                  placeholder="Enter your comment here..."
                  v-textAreaUppercase=globalSettingItem.conEverythingToCaps
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="input-text-size">
          <v-spacer></v-spacer>
          <v-btn      :class="`input-text-size`"
            text color="blue darken-1"
             small @click="closeCommentDialog">Cancel</v-btn>
          <v-btn   :class="`input-text-size`"
            text color="blue darken-1" small @click="handleBulkCommentSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- section for show warning message -->
     <CommonPopUp v-model="showOrHideWarningMessage" v-if="showOrHideWarningMessage"
        :enableFlashTypeMsg="true" flashType="warning">
        <template v-slot:customsLabelOrInfo>
          <div v-if="warningMessage && warningMessage !==undefined">
            <div v-for="(message, index) in warningMessage" :key="index"
             class="mt-3 d-flex align-start">
               <p style="white-space: pre;">
            <v-icon :class="handleCircleClass('statusCodePayment')">
              {{ icons.mdiCircleSlice8 }}
            </v-icon> {{ message }}
          </p>
            </div>
          </div>
        </template>
        <template v-slot:[`customsButtonsForPopUp`]="{}">
          <v-btn class="input-text-size payment-transaction-list-continue-btn"
          id="paymentTransactionListContinueBtn"
           text color="blue darken-1"
          @click="openConfirmPopUp('Continue')">Continue</v-btn>
          <v-btn class="input-text-size payment-transaction-list-cancel-btn"
          id="paymentTransactionListCancelBtn"
          text color="blue darken-1"
          @click="openConfirmPopUp('Cancel')">Cancel</v-btn>
        </template>
      </CommonPopUp>
  </div>
</template>

<script>
import {
  mdiCircleSlice8,
} from '@mdi/js';
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import CRUDList from '../../../../components/common/base/crud-2.0/CRUDList.vue';
import largePaymentHeaders from '../../../../components/tax/TaxRollAdjustments/TaxRollAdjustmentsUtils/paymentHeaders.util';
import CommonPopUp from '../../../../components/tax/common-utils/CommonPopUp.vue';
import { getFeeListBasedOnEffeciveDate, taxReasonListDropDownPostProcessTrans } from '../../../../components/tax/common-utils/CommonTaxFunctionalities';
import PaymentCommonFuncMixin from '../../../../components/tax/common-utils/PaymentCommonFunc.mixin';
import { exemptManufacturingStatusCode, penaltyCalculation } from '../../../../components/tax/common-utils/tax-common.util';
import dialogTaxDetails from '../../../../components/tax/payments/paymenteditDialog/dialogTaxDetails.vue';
import { toShortDate } from '../../../../util/shared/tmc-global';
import { amountFormat, amountToNumber } from '../../../../util/shared/vue-global';
import TaxEditDialog from './TaxEditDialog.vue';
import CommonDropDowns from '../../../../components/tax/common-utils/CommonDropDowns.mixin.vue';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  name: 'LargePaymentList',
  mixins: [PaymentCommonFuncMixin, GlobalToCaps],

  components: {
    CRUDList,
    TaxEditDialog,
    dialogTaxDetails,
    CommonPopUp,
    CommonDropDowns,
  },
  props: {
    fiscalYear: {
      type: [String, Number],
      required: false,
      default: null,
    },
    paymentNumber: {
      type: [String, Number],
      required: false,
      default: null,
    },
    taxDetails: {
      type: Array,
      required: false,
      default: () => [],
    },
    totalDue: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    totalPaid: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    cashChange: {
      type: [String, Number],
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      baseCrudKey: 'largePaymentList',
      addTaxCrudKey: 'largePaymentListAddNew', // Separate crud key for adding items
      dialogHeaderName: 'Payment Transactions',
      headers: this.buildHeaders(),
      editDialog: false,
      editedIndex: -1,
      newTaxDetailsToAdd: [], // Separate array for new items being added
      addTaxPanelExpanded: undefined, // Controls expansion panel state (undefined = collapsed)
      halfPaymentFlag: false,
      loading: false,
      showOrHideWarningMessage: false,
      warningMessage: [],
      mtgCodeErrorList: [],
      icons: {
        mdiCircleSlice8,
      },
      textName: {
        txtName: 'defaultText', // You can change this based on your logic
      },
      // API-side totals (from largePaymentRecords API - not affected by pagination)
      serverTotals: {
        totalTaxAmt: 0,
        totalDue: 0,
        totalPenalty: 0,
        totalFees: 0,
        totalRecords: 0,
      },
      commentData: {
        category: 7, // Default category for user comments
        reasonCode: null,
        addToLegal: false,
        sendToWebsite: false,
        rollToNextYear: false,
        comment: '',
      },
      commentDialog: false,
    };
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'items', 'item']),
    ...mapGetters('user', ['getSettings']),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
      paymentSettingItem: (state) => state.SystemConfig.paymentSettingItem || {},
      reasonListDropDown: (state) => state.base.crud.items.reasonListDropDown,
      skipNextApiCallForLargePayments: (state) => state
        .tax.taxPayment.skipNextApiCallForLargePayments || false,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    defaultSortBy() {
      return [
        {
          column: 'taxYear',
          direction: 'desc',
        },
        {
          column: 'taxId',
          direction: 'desc',
        },

      ];
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    editedItem: {
      get() {
        return this.item('pickListMakePaymentDialog');
      },
      set(value) {
        this.setItem(['pickListMakePaymentDialog', value]);
      },
    },
    skipNextApiCallForLargePaymentsFlag: {
      // Flag to prevent unnecessary API calls for large payments
      get() {
        return this.skipNextApiCallForLargePayments;
      },
      set(value) {
        this.setSkipNextApiCallForLargePayments(value);
      },
    },
    // Calculate totals - use API totals for pagination, fallback to client-side
    calculatedTotals() {
      // If we have server-side totals from API, use them (accurate across all pages)
      if (this.serverTotals && this.serverTotals.totalRecords > 0) {
        return {
          taxAmt: amountToNumber(this.serverTotals.totalTaxAmt),
          penaltyAmt: amountToNumber(this.serverTotals.totalPenalty),
          totalFees: amountToNumber(this.serverTotals.totalFees),
          total: amountToNumber(this.serverTotals.totalDue),
          totalRecords: this.serverTotals.totalRecords || 0,
        };
      }

      // Fallback: Calculate from current page data (for picklist mode)
      const items = this.items(this.baseCrudKey) || [];
      // Include items that are TAXPAYMENT or don't have taxType set (new items)
      const taxItemsWithTaxPaymentTaxType = (items || [])
        .filter((item) => !item.taxType || item.taxType === 'TAXPAYMENT' || item.taxType === 'TAXREFUND') || [];
      return {
        taxAmt: taxItemsWithTaxPaymentTaxType
          .reduce((sum, item) => sum + amountToNumber(item.taxAmt), 0),
        penaltyAmt: taxItemsWithTaxPaymentTaxType
          .reduce((sum, item) => sum + amountToNumber(item.penaltyAmt), 0),
        totalFees: taxItemsWithTaxPaymentTaxType
          .reduce((sum, item) => sum + amountToNumber(item.totalFees), 0),
        total: taxItemsWithTaxPaymentTaxType
          .reduce((sum, item) => sum + amountToNumber(item.total), 0),
        totalRecords: items.length,
      };
    },
    // Check if there are valid items ready to be added
    hasValidItemsToAdd() {
      if (!this.newTaxDetailsToAdd || this.newTaxDetailsToAdd.length === 0) {
        return false;
      }
      // Enable button when there are items that have been fetched (have ownerName populated)
      return this.newTaxDetailsToAdd.some((item) => item.taxYear
        && item.taxId
        && item.ownerName);
    },
  },
  methods: {
    buildHeaders(showCert) {
      const useCert = showCert !== undefined
        ? showCert
        : ((this.paymentSettingItem || {}).showCertNumberOnPaymentScreen || false);
      const headers = largePaymentHeaders.map((h) => {
        if (h.value === 'reciept') {
          return useCert
            ? { ...h, text: 'Cert No', value: 'certNumber' }
            : h;
        }
        return h;
      });
      // A voided row is otherwise only distinguishable by its zeroed amounts. dialogTaxDetails
      // has always carried the flag, so the list shows it too - appended here rather than in
      // the shared header list, which the standalone large-payments view also uses.
      return [...headers, {
        text: 'Void',
        value: 'void',
        align: 'center',
        sortable: false,
        formatter: 'flagToYorEmpty',
      }];
    },
    ...mapActions('tax/taxPayment', [
      'loadLargePayments',
      'pickListLargePayments',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
      'setItem',
      'setItems',
      'setPaginationItems',
    ]),
    ...mapMutations('tax/taxPayment', [
      'setHalfOrPostmark',
      'setPaymentShotCutStore',
      'setSkipNextApiCallForLargePayments',
    ]),
    ...mapActions('shared/taxReasonCode', [
      'loadReasonCode',
    ]),
    ...mapActions('tax/taxComments', [
      'bulkUpsertComments',
    ]),
    ...mapActions(['flashWarn']),
    /* ------------------------------------------------------------------------------------
     * ONE place rows are written on this screen.
     *
     * This screen keeps the payment's rows in TWO stores - the payment record's
     * editedItem.taxDetails (crud key 'pickListMakePaymentDialog') and the grid's own items
     * (crud key 'largePaymentList') - and every write path used to update them with its own
     * setItem/setItems/emit combination. When two of those paths ran for the same row (the
     * newTaxDetailsToAdd watcher and addToList both commit a staged row, and only the watcher
     * de-duplicated) the save payload ended up carrying a copy from each store.
     *
     * That is Pontotoc payment 719: one create payload with 2023/9804 on it twice, receipts
     * 29848 and 29849, 875.15 each, against a single 875.15 card. It was out of balance from
     * creation and the cleanup was manual.
     *
     * So: commitTaxRows is the only writer. It de-duplicates, writes both stores from the same
     * array, emits once, and recomputes the footer. Everything that changes rows - the staged
     * "Add Tax Details" commit, the unpaids/parcel auto-load, a row edit or void from
     * TaxEditDialog, a row delete - goes through it.
     * ---------------------------------------------------------------------------------- */

    /**
     * What makes two rows the same line. Deliberately not taxYear/taxId alone: the same parcel
     * may legitimately appear twice on one payment as a payment line and a refund line, or as a
     * protested and an unprotested portion. Mirrors the server's own guard
     * (findDuplicateLiveTaxDetail in taxPayments.util.js) so the two agree on what a duplicate is.
     *
     * Returns '' for a row that is not yet resolved to a parcel - a half-typed row is not a
     * duplicate of anything.
     */
    taxRowIdentity(row) {
      const taxYear = amountToNumber(row.taxYear);
      // A row keyed by parcel ID carries the typed PID in taxId and the resolved tax ID in
      // originalTaxId; upsertNOverPaymentsCommon sends the resolved one, so match on that.
      const taxId = amountToNumber(row.originalTaxId) || amountToNumber(row.taxId);
      if (!taxYear || !taxId) return '';
      return [taxYear, taxId, row.taxType || 'TAXPAYMENT', row.protest ? 1 : 0].join('|');
    },
    // A row already written to paymenttaxdetails outranks an unsaved copy of the same line:
    // dropping the saved one would orphan the stored row instead of correcting the duplicate.
    taxRowRank(row) {
      if (row._id) return 2;
      if (row.reciept) return 1;
      return 0;
    },
    /**
     * Collapses duplicate LIVE rows, keeping the saved copy where there is one.
     *
     * Void and posted rows are passed through untouched and never participate: voiding a row is
     * how a clerk corrects a duplicate, and a parcel whose earlier line was voided may genuinely
     * be added again.
     */
    dedupeTaxRows(rows) {
      const kept = [];
      const keptIndexByKey = new Map();
      const dropped = [];
      (rows || []).forEach((row) => {
        if (!row) return;
        const isLive = !row.void && !row.tempVariableVoid && !row.posted;
        const key = isLive ? this.taxRowIdentity(row) : '';
        if (!key) {
          kept.push(row);
          return;
        }
        const existingIndex = keptIndexByKey.get(key);
        if (existingIndex === undefined) {
          keptIndexByKey.set(key, kept.push(row) - 1);
          return;
        }
        const existing = kept[existingIndex];
        if (this.taxRowRank(row) > this.taxRowRank(existing)) {
          kept[existingIndex] = row;
          dropped.push(existing);
        } else {
          dropped.push(row);
        }
      });
      return { rows: kept, dropped };
    },
    /**
     * Writes `nextRows` as THE rows of this payment: the grid and the payment record both get
     * this exact array, the parent is told once, and the footer totals are recomputed.
     *
     * addedItems / deletedItems only feed the delta-based footer maths
     * (updateLocalTotalsAndPagination); the rows themselves always come from nextRows.
     */
    commitTaxRows(nextRows, { addedItems = [], deletedItems = [], warnOnDuplicate = true } = {}) {
      const { rows, dropped } = this.dedupeTaxRows(nextRows);
      if (warnOnDuplicate) {
        dropped.forEach((row) => this.flashWarn(
          `Tax Yr ${row.taxYear} Tax ID ${row.originalTaxId || row.taxId} has already been added to this payment.`,
        ));
      }

      // Purely local: nothing here needs re-fetching, and a reload would undo the write.
      this.skipNextApiCallForLargePaymentsFlag = true;

      this.setItems([this.baseCrudKey, rows]);
      // NOT setItem([baseCrudKey, ...]) as addToList used to do: that slot holds the single row
      // TaxEditDialog is editing, and writing the whole payment into it replaces the row under
      // an open dialog. The grid's rows live in items(baseCrudKey); the payment lives in
      // item('pickListMakePaymentDialog').
      this.setItem(['pickListMakePaymentDialog', { ...(this.editedItem || {}), taxDetails: rows }]);
      this.$emit('taxDetailsChanged', rows);

      const keptAdded = (addedItems || []).filter((item) => !dropped.includes(item));
      this.updateLocalTotalsAndPagination(rows, keptAdded, deletedItems);

      this.$nextTick(() => {
        setTimeout(() => {
          this.skipNextApiCallForLargePaymentsFlag = false;
        }, 500);
      });
      return { rows, dropped };
    },
    /**
     * Whether `row` is the row `target` describes. Identity first (_id, then receipt), and only
     * then the parcel pair - two live lines for one parcel would otherwise both answer yes, which
     * is how voiding ONE of a duplicated pair in TaxEditDialog could land on the wrong row or on
     * both of them.
     */
    isSameTaxRow(row, target) {
      if (row._id && target._id) return String(row._id) === String(target._id);
      if (row.reciept && target.reciept) return row.reciept === target.reciept;
      if (row._id || target._id || row.reciept || target.reciept) return false;
      return row.taxYear === target.taxYear
        && row.taxId === target.taxId
        && row.protest === target.protest;
    },
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
    addComments() {
      // Reset comment data to default values
      this.commentData = {
        category: 7, // Default category for user comments
        reasonCode: null,
        addToLegal: false,
        sendToWebsite: false,
        rollToNextYear: false,
        comment: '',
      };
      this.commentDialog = true;
    },
    async handleBulkCommentSave() {
      if (!this.commentData.comment || !this.commentData.comment.trim()) {
        this.flashWarn('Please enter a comment');
        return;
      }

      // Prepare bulk comment data for all tax records
      const taxRecords = (this.editedItem || {}).taxDetails.filter((item) => item.taxYear && item.taxId);

      if (taxRecords.length === 0) {
        this.flashWarn('No valid tax records found to add comments');
        return;
      }

      try {
        // Create comment entries for each tax record
        const commentEntries = taxRecords.map((taxRecord) => ({
          taxYear: amountToNumber(taxRecord.taxYear),
          taxId: amountToNumber(taxRecord.taxId),
          category: this.commentData.category,
          reasonCode: this.commentData.reasonCode,
          addToLegal: this.commentData.addToLegal,
          sendToWebsite: this.commentData.sendToWebsite,
          rollToNextYear: this.commentData.rollToNextYear,
          comment: this.commentData.comment,
          userName: this.userName,
          taxInquiryTransaction: taxRecord.taxInquiryId,
        }));
        await this.bulkUpsertComments({ item: commentEntries });

        this.commentDialog = false;
        // Reset comment data
        this.commentData = {
          category: 7,
          reasonCode: null,
          addToLegal: false,
          sendToWebsite: false,
          rollToNextYear: false,
          comment: '',
        };
      } catch (error) {
        console.error('Error saving bulk comments:', error);
        this.flashWarn('There was a problem saving the comments');
      }
    },
    closeCommentDialog() {
      this.commentDialog = false;
      // Reset comment data
      this.commentData = {
        category: 7,
        reasonCode: null,
        addToLegal: false,
        sendToWebsite: false,
        rollToNextYear: false,
        comment: '',
      };
    },
    // Cleanup method called when component is about to be destroyed or dialog closes
    resetStoreData() {
      // strategy - Clear CRUD store data on close rather than on load
      this.setItems([this.baseCrudKey, []]);
      this.setCriteria([this.baseCrudKey, {}]);

      // Reset component-level state
      this.serverTotals = {
        totalTaxAmt: 0,
        totalDue: 0,
        totalPenalty: 0,
        totalFees: 0,
        totalRecords: 0,
      };
      this.newTaxDetailsToAdd = [];
      this.halfPaymentFlag = false;
    },
    // Create footer totals array based on headers and calculated totals
    footerTotals() {
      const totals = [];
      const calculated = this.calculatedTotals;
      // Use totalRecords from API if available, otherwise current page count
      const rowCount = calculated.totalRecords
        || (this.items(this.baseCrudKey) || []).length;

      this.headers.forEach((header, index) => {
        switch (header.value) {
          case 'taxId':
            totals[index] = 'Totals';
            break;
          case 'ownerName':
            totals[index] = `#${rowCount}`;
            break;
          case 'taxAmt':
            totals[index] = calculated.taxAmt.toFixed(2);
            break;
          case 'penaltyAmt':
            totals[index] = calculated.penaltyAmt.toFixed(2);
            break;
          case 'totalFees':
            totals[index] = calculated.totalFees.toFixed(2);
            break;
          case 'total':
            // Show calculated total from table data
            totals[index] = calculated.total.toFixed(2);
            break;
          default:
            totals[index] = null;
            break;
        }
      });
      return totals;
    },
    // Check for mortgage codes in tax details and build warning messages
    checkForMortgageCodes(taxDetails) {
      const mtgCodeWarnings = [];
      this.mtgCodeErrorList = [];

      if (!this.paymentSettingItem.warnWhenPayingRecWithMtg) {
        return mtgCodeWarnings;
      }

      (taxDetails || []).forEach((item) => {
        if (item.mtgCode && item.mtgCode.trim() !== '') {
          mtgCodeWarnings.push(
            `Tax Yr ${item.taxYear} Tax ID ${item.taxId} is coded with the mortgage code ${item.mtgCode}.`,
          );
          this.mtgCodeErrorList.push({
            taxYear: item.taxYear,
            taxId: item.taxId,
            mtgCode: item.mtgCode,
          });
        }
      });

      return mtgCodeWarnings;
    },
    async loadLargePaymentData() {
      // Use internal values if available, otherwise fall back to props
      const currentFiscalYear = this.internalFiscalYear || this.fiscalYear;
      const currentPaymentNumber = this.internalPaymentNumber || this.paymentNumber;

      // be double-sure largePaymentList items are clear for UI/UX purposes
      this.setItems([this.baseCrudKey, []]);
      if (!currentFiscalYear || !currentPaymentNumber) {
        return;
      }
      if (this.skipNextApiCallForLargePaymentsFlag) {
        return;
      }
      try {
        this.loading = true;
        const criteria = {
          fiscalYear: Number(currentFiscalYear),
          paymentNumber: Number(currentPaymentNumber),
          skip: this.criteriaState.skip || 0,
          limit: this.criteriaState.limit || 100,
        };
        const res = await this.loadLargePayments({
          baseCrudKey: this.baseCrudKey,
          criteria,
          // fields: ['*', 'taxpayer { * }', 'taxDetails { * }'],
          postProcessTrans: this.postProccessData,
        });
        // Initialize the item structure if it doesn't exist
        if (res && !res.paymentDetails) {
          res.paymentDetails = [];
        }

        // Store server-side totals from API (not affected by pagination)
        if (res) {
          this.serverTotals = {
            totalTaxAmt: parseFloat(res.totalTaxAmt) || 0,
            totalDue: parseFloat(res.totalDue) || 0,
            totalPenalty: parseFloat(res.totalPenalty) || 0,
            totalFees: parseFloat(res.totalFees) || 0,
            totalRecords: parseInt(res.totalRecords, 10) || 0,
          };

          // Update pagination with server items length for proper pagination
          if (this.serverTotals.totalRecords > 0) {
            const paginationItem = {
              itemsperpage: this.criteriaState.limit || 100,
              serverItemsLength: this.serverTotals.totalRecords,
              footerProps: {
                'items-per-page-options': [10, 25, 50, 100, 200],
                'show-current-page': true,
                'show-first-last-page': true,
              },
            };
            this.setPaginationItems([this.baseCrudKey, paginationItem]);
          }
        }

        // Preserve fiscalYear and paymentNumber to prevent component recreation loop
        // (slight performance improvement, possibly helps fix the payment flashing issue)
        const fiscalYearToUse = this.editedItem.fiscalYear === res.fiscalYear
          ? this.editedItem.fiscalYear
          : res.fiscalYear;

        const paymentNumberToUse = this.editedItem.paymentNumber === res.paymentNumber
          ? this.editedItem.paymentNumber
          : res.paymentNumber;

        const preservedItem = {
          ...res,
          fiscalYear: fiscalYearToUse,
          paymentNumber: paymentNumberToUse,
        };
        this.setItem([this.baseCrudKey, preservedItem]);
        this.editedItem = preservedItem;
      } catch (error) {
        // Handle error appropriately
        this.$store.dispatch('flashError', 'Failed to load payment data');
      } finally {
        this.loading = false;
      }
    },
    async handleLoadCRUDList() {
      // Skip API call if flag is set
      if (this.skipNextApiCallForLargePaymentsFlag) {
        // Don't reset flag here, let it be reset after the operation completes
        return {};
      }

      // Clear previous warning messages to prevent duplicates
      this.warningMessage = [];
      this.showOrHideWarningMessage = false;

      // For pagination mode, always call API on page/limit change
      if (this.fiscalYear && this.paymentNumber) {
        await this.loadLargePaymentData();
      } else {
        const getCriteria = this.criteria('pickListMakePaymentDialog');
        delete getCriteria.skip;
        delete getCriteria.limit;
        delete getCriteria.isItFromProfile;
        if (getCriteria.halfPayment === true) {
          this.setHalfOrPostmark({ res: true, whichOne: 'dialogHalf' });
        }

        try {
          const res = await this.pickListLargePayments({
            baseCrudKey: this.baseCrudKey,
            criteria: getCriteria,
            postProcessTrans: this.postProccessData,
          });
          if (res.warningMessage && (res.warningMessage || []).length > 0) {
            this.showOrHideWarningMessage = true;
            this.warningMessage = Array.isArray(res.warningMessage)
              ? res.warningMessage
              : [res.warningMessage];
          }

          // Check for mortgage codes in the loaded tax details
          if (res.taxDetails && res.taxDetails.length > 0) {
            const mtgWarnings = this.checkForMortgageCodes(res.taxDetails);
            if (mtgWarnings.length > 0) {
              this.showOrHideWarningMessage = true;
              // If there's already a warning message, combine them
              if (this.warningMessage && (this.warningMessage || []).length > 0) {
                // If warningMessage is a string, convert to array
                const existingMessages = Array.isArray(this.warningMessage)
                  ? this.warningMessage
                  : [this.warningMessage];
                this.warningMessage = [...existingMessages, ...mtgWarnings];
              } else {
                this.warningMessage = mtgWarnings;
              }
            }
          }

          // Preserve fiscalYear to prevent component recreation loop
          // (slight performance improvement, possibly helps fix the payment flashing issue)
          const fiscalYearToUse = this.editedItem.fiscalYear === res.fiscalYear
            ? this.editedItem.fiscalYear // Same value, use existing ref
            : res.fiscalYear; // Different value, allow update

          const currentItem = {
            ...this.editedItem,
            taxDetails: res.taxDetails,
            fiscalYear: fiscalYearToUse,
            workstation: Number(this.editedItem.workstation) || null,
          };
          if (currentItem.halfPaymentFlag) {
            this.halfPaymentFlag = true;
          }
          this.setItem(['pickListMakePaymentDialog', currentItem]);

          // Initialize serverTotals for picklist mode from the loaded data
          const taxDetails = res.taxDetails || [];
          const taxItems = taxDetails.filter((item) => !item.taxType || item.taxType === 'TAXPAYMENT' || item.taxType === 'TAXREFUND');
          this.serverTotals = {
            totalTaxAmt: taxItems.reduce((sum, item) => sum + amountToNumber(item.taxAmt), 0),
            totalDue: taxItems.reduce((sum, item) => sum + amountToNumber(item.total), 0),
            totalPenalty: taxItems.reduce((sum, item) => sum + amountToNumber(item.penaltyAmt), 0),
            totalFees: taxItems.reduce((sum, item) => sum + amountToNumber(item.totalFees), 0),
            totalRecords: taxDetails.length,
          };

          // Update pagination for picklist mode
          const paginationItem = {
            itemsperpage: this.getSettings.itemsperpage || 100,
            serverItemsLength: this.serverTotals.totalRecords,
            footerProps: {
              'items-per-page-options': [10, 25, 50, 100, 200],
              'show-current-page': true,
              'show-first-last-page': true,
            },
          };
          this.setPaginationItems([this.baseCrudKey, paginationItem]);
        } catch (error) {
          console.error('Error reloading tax details with new penalty date:', error);
        }
      }
      return {};
    },
    editItem(item) {
      const currentItems = this.items(this.baseCrudKey) || [];
      this.editedIndex = Array.isArray(currentItems) ? currentItems.indexOf(item) : -1;
      this.editedItem = { ...item };
      this.editDialog = true;
    },
    closeEditDialog() {
      this.editDialog = false;
      this.$nextTick(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      });
    },
    async saveItem(item) {
      try {
        // Here you would typically make an API call to save the item
        // For now, we'll just update the local data
        const currentItems = this.items(this.baseCrudKey) || [];
        if (this.editedIndex > -1 && Array.isArray(currentItems)) {
          // Update existing item in the store
          const updatedItems = [...currentItems];
          updatedItems[this.editedIndex] = item;
          this.setItems([this.baseCrudKey, updatedItems]);
        }
        // Show success message
        this.$store.dispatch('flashSuccess', 'Tax payment updated successfully');

        // Optionally reload data to get fresh data from server
        // await this.loadLargePaymentData();
      } catch (error) {
        this.$store.dispatch('flashError', 'Failed to save tax payment');
      }
    },
    handleTaxDetailChanged(updatedItem) {
      // Set flag to prevent API call
      this.skipNextApiCallForLargePaymentsFlag = true;

      // Define allowed fields based on GraphQL schema
      const allowedFields = [
        '_id',
        'taxYear',
        'taxId',
        'schoolDistrict',
        'taxAmt',
        'penaltyAmt',
        'mailFee',
        'lienFee',
        'advFee',
        'otherFee',
        'total',
        'feeNumber',
        'void',
        'isItNewVoidedRecord',
        'isItFromPaymentTaxDetails',
        'itsNewRecord',
        'protest',
        'posted',
        'totalDue',
        'reciept',
        'taxType',
        // display-only (Tax Type column); not in taxDetailsInputFields, so
        // upsertNOverPaymentsCommon strips it before the upsert
        'propertyTaxType',
        'fees',
        'statusCode',
        'totalFees',
        'grossAssessed',
        'exemptions',
        'ownerName',
        'originalTaxId',
        'originalTaxAmount',
        'tempVariableVoid',
        'initialTaxAmt',
        'initialPenaltyAmt',
        'initialTotalFees',
        'initialFees',
        'initialTaxYear',
        'initialTaxId',
        'AIsVisible',
        'auditSummary',
        'Half',
        'disableHalf',
        // Transient lookup values TaxEditDialog repopulates when the clerk retargets a row's
        // Tax Yr / Tax ID. Kept client-side because the display columns (certNumber), the
        // penalty recalc (recalculatePenaltiesForPicklist) and the mtg warning
        // (checkForMortgageCodes) all read them back. Safe to carry: upsertNOverPaymentsCommon
        // deletes every one of these before the upsert, so none reach the GraphQL payload.
        'certNumber',
        'taxInquiryId',
        'totalTax',
        'totalPaid',
        'taxTotalDue',
        'penaltyStartDate',
        'penaltyChangedManually',
        'allFeesList',
        'mtgCode',
        'mobileHome',
        'baseId',
        'originalTaxAmt',
        'originalGrossAssessed',
        'allowBackTaxEdit',
      ];

      // Filter updatedItem to only include allowed fields
      const validateAndFilterFields = (item) => {
        const filteredItem = {};
        allowedFields.forEach((field) => {
          if (Object.prototype.hasOwnProperty.call(item, field)) {
            filteredItem[field] = item[field];
          }
        });
        // Explicitly remove Vuetify's internal selection tracking property
        delete filteredItem.selected;
        return filteredItem;
      };

      // Validate and filter the updated item
      const validatedUpdatedItem = validateAndFilterFields(updatedItem);

      // Find the original item before update (for calculating difference in totals)
      const currentTaxDetails = this.items(this.baseCrudKey) || [];
      let originalItem = null;

      // Replace the FIRST row this describes and no other. The old version replaced every row
      // matching taxYear/taxId/protest, so on a payment that carried a parcel twice a void from
      // TaxEditDialog could land on the wrong line or on both - and it wrote the grid and the
      // payment record from two separately-computed arrays, which is how a save could go out
      // still carrying the pre-void row.
      const updatedTaxDetails = currentTaxDetails.map((item) => {
        // eslint-disable-next-line no-param-reassign
        item.originalTaxId = item.taxId;
        if (!originalItem && this.isSameTaxRow(item, validatedUpdatedItem)) {
          originalItem = { ...item };
          return { ...validatedUpdatedItem };
        }
        return item;
      });

      // One write, both stores, one emit - see commitTaxRows.
      this.commitTaxRows(updatedTaxDetails, {
        addedItems: originalItem ? [validatedUpdatedItem] : [],
        deletedItems: originalItem ? [originalItem] : [],
      });
    },
    handleTaxDetailDeleted(deletedItem) {
      const currentTaxDetails = this.items(this.baseCrudKey) || [];

      // Same first-match-only rule as handleTaxDetailChanged: deleting one of two lines for a
      // parcel must not take both.
      let removed = false;
      const updatedTaxDetails = currentTaxDetails.filter((item) => {
        if (!removed && this.isSameTaxRow(item, deletedItem)) {
          removed = true;
          return false;
        }
        return true;
      });

      this.commitTaxRows(updatedTaxDetails, { deletedItems: removed ? [deletedItem] : [] });
    },
    isAllTaxDetailsPosted() {
      // Check if all tax details in editedItem are posted
      const taxDetails = (this.editedItem && this.editedItem.taxDetails) || [];
      if (taxDetails.length === 0) {
        return false; // Show dialogTaxDetails if no items
      }
      // Return false if NOT all posted (show dialogTaxDetails for unposted items)
      const allPosted = taxDetails.every((item) => item.posted === true);
      return allPosted;
    },
    // Update serverTotals and pagination after local add/delete operations
    // addedItems: items being added (to sum with existing serverTotals)
    // deletedItems: items being deleted (to subtract from existing serverTotals)
    updateLocalTotalsAndPagination(allItems, addedItems = [], deletedItems = []) {
      // Calculate totals for added items
      // Include items that are TAXPAYMENT or don't have taxType set (new items)
      const addedTaxItems = (addedItems || [])
        .filter((item) => !item.taxType || item.taxType === 'TAXPAYMENT' || item.taxType === 'TAXREFUND') || [];
      const addedTotals = {
        taxAmt: addedTaxItems
          .reduce((sum, item) => sum + amountToNumber(item.taxAmt), 0),
        penalty: addedTaxItems
          .reduce((sum, item) => sum + amountToNumber(item.penaltyAmt), 0),
        fees: addedTaxItems
          .reduce((sum, item) => sum + amountToNumber(item.totalFees), 0),
        total: addedTaxItems
          .reduce((sum, item) => sum + amountToNumber(item.total), 0),
      };

      // Calculate totals for deleted items
      // Include items that are TAXPAYMENT or don't have taxType set
      const deletedTaxItems = (deletedItems || [])
        .filter((item) => !item.taxType || item.taxType === 'TAXPAYMENT' || item.taxType === 'TAXREFUND') || [];
      const deletedTotals = {
        taxAmt: deletedTaxItems
          .reduce((sum, item) => sum + amountToNumber(item.taxAmt), 0),
        penalty: deletedTaxItems
          .reduce((sum, item) => sum + amountToNumber(item.penaltyAmt), 0),
        fees: deletedTaxItems
          .reduce((sum, item) => sum + amountToNumber(item.totalFees), 0),
        total: deletedTaxItems
          .reduce((sum, item) => sum + amountToNumber(item.total), 0),
      };

      // If serverTotals exist from API, add/subtract from them
      if (this.serverTotals && this.serverTotals.totalRecords > 0) {
        this.serverTotals = {
          totalTaxAmt: amountToNumber(this.serverTotals.totalTaxAmt)
            + addedTotals.taxAmt - deletedTotals.taxAmt,
          totalDue: amountToNumber(this.serverTotals.totalDue)
            + addedTotals.total - deletedTotals.total,
          totalPenalty: amountToNumber(this.serverTotals.totalPenalty)
            + addedTotals.penalty - deletedTotals.penalty,
          totalFees: amountToNumber(this.serverTotals.totalFees)
            + addedTotals.fees - deletedTotals.fees,
          totalRecords: (this.serverTotals.totalRecords || 0)
            + addedItems.length - deletedItems.length,
        };
      } else {
        // No serverTotals, calculate from all items
        // Include items that are TAXPAYMENT or don't have taxType set
        const taxItems = (allItems || [])
          .filter((item) => !item.taxType || item.taxType === 'TAXPAYMENT' || item.taxType === 'TAXREFUND') || [];

        this.serverTotals = {
          totalTaxAmt: taxItems
            .reduce((sum, item) => sum + amountToNumber(item.taxAmt), 0),
          totalDue: taxItems
            .reduce((sum, item) => sum + amountToNumber(item.total), 0),
          totalPenalty: taxItems
            .reduce((sum, item) => sum + amountToNumber(item.penaltyAmt), 0),
          totalFees: taxItems
            .reduce((sum, item) => sum + amountToNumber(item.totalFees), 0),
          totalRecords: allItems.length,
        };
      }

      // Update pagination with new total records
      const paginationItem = {
        itemsperpage: this.criteriaState.limit || 100,
        serverItemsLength: this.serverTotals.totalRecords,
        footerProps: {
          'items-per-page-options': [10, 25, 50, 100, 200],
          'show-current-page': true,
          'show-first-last-page': true,
        },
      };
      this.setPaginationItems([this.baseCrudKey, paginationItem]);
    },
    /**
     * Totals for a given set of rows. Separate from updateLocalTotalsAndPagination, which
     * works in deltas off the existing serverTotals - no use when the rows were rewritten
     * wholesale (Void All) rather than added to or removed from.
     */
    totalsFromRows(rows) {
      const taxItems = (rows || [])
        .filter((item) => !item.taxType || item.taxType === 'TAXPAYMENT' || item.taxType === 'TAXREFUND');
      return {
        totalTaxAmt: taxItems.reduce((sum, item) => sum + amountToNumber(item.taxAmt), 0),
        totalDue: taxItems.reduce((sum, item) => sum + amountToNumber(item.total), 0),
        totalPenalty: taxItems.reduce((sum, item) => sum + amountToNumber(item.penaltyAmt), 0),
        totalFees: taxItems.reduce((sum, item) => sum + amountToNumber(item.totalFees), 0),
        totalRecords: (rows || []).length,
      };
    },
    /**
     * Re-seeds the grid from the parent payment's taxDetails and recomputes the footer from
     * them. This list keeps its OWN copy of the rows under `largePaymentList`, so a header-side
     * change that rewrites taxDetails wholesale - Void All - has to be pushed in here. Without
     * it the grid keeps rendering the live amounts, and the next thing it emits (a row edit, an
     * added row, a delete) hands those un-voided rows back to the parent and undoes the void.
     */
    syncRowsFromPayment(taxDetails) {
      const rows = [...(taxDetails || [])];
      // a purely local re-seed: there is nothing new to fetch
      this.skipNextApiCallForLargePaymentsFlag = true;
      this.setItems([this.baseCrudKey, rows]);

      const totals = this.totalsFromRows(rows);
      // On a server-paginated payment only the current page is in `rows` - and Void All only
      // voids that page - so the money figures follow the rows we were handed while the record
      // count stays at the full count, or pagination would collapse to one page.
      this.serverTotals = {
        ...totals,
        totalRecords: Math.max(totals.totalRecords, this.serverTotals.totalRecords || 0),
      };
      this.setPaginationItems([this.baseCrudKey, {
        itemsperpage: this.criteriaState.limit || this.getSettings.itemsperpage || 100,
        serverItemsLength: this.serverTotals.totalRecords,
        footerProps: {
          'items-per-page-options': [10, 25, 50, 100, 200],
          'show-current-page': true,
          'show-first-last-page': true,
        },
      }]);

      this.$nextTick(() => {
        setTimeout(() => {
          this.skipNextApiCallForLargePaymentsFlag = false;
        }, 500);
      });
    },
    /**
     * Commits the rows staged in "Add Tax Details" now that ADD TO LIST is hidden. Reached
     * from the '+' button (commitStagedTaxRows) and from a finished unpaids / parcel load
     * (unpaidTaxesAdded, once the clerk has cleared any warning modal it raised).
     * Guarded on hasValidItemsToAdd for the same reason handlePaymentFieldActivity is:
     * addToList's empty-list `return` is commented out, so calling it with nothing complete
     * flashes both "already been added" and "0 item(s) added to payment". Both triggers can
     * legitimately fire with only a blank row staged, so this check is required.
     */
    commitStagedTaxRows() {
      if (this.hasValidItemsToAdd) {
        this.addToList();
      }
    },
    addToList() {
      // Manually trigger adding items from newTaxDetailsToAdd to main list
      if (!this.newTaxDetailsToAdd || this.newTaxDetailsToAdd.length === 0) {
        this.$store.dispatch('flashWarn', 'No items to add.');
        return;
      }

      const baseItems = this.items(this.baseCrudKey) || [];

      // Filter items that are complete and ready to add. The duplicate check that used to live
      // here was commented out, which is what let this path append a row the newTaxDetailsToAdd
      // watcher had already committed - the two copies of 2023/9804 on Pontotoc 719. It now
      // belongs to commitTaxRows, so there is exactly ONE rule and ONE warning.
      const completeItems = this.newTaxDetailsToAdd.filter((newItem) => newItem.taxYear
        && newItem.taxId
        && newItem.ownerName);

      // Nothing resolved yet - the clerk is still typing. Re-committing the unchanged rows would
      // only churn the stores (the old code fell through and flashed a misleading warning).
      if (completeItems.length === 0) {
        return;
      }

      const { dropped } = this.commitTaxRows([...baseItems, ...completeItems], {
        addedItems: completeItems,
      });

      // Clear the staged items that were handled - whether they were added or rejected as
      // duplicates. Leaving a rejected row staged would re-offer it on the next commit.
      this.newTaxDetailsToAdd = this.newTaxDetailsToAdd.filter((item) => {
        const wasHandled = completeItems.some((handledItem) => (
          String(handledItem.taxYear) === String(item.taxYear)
          && String(handledItem.taxId) === String(item.taxId)
        ));
        return !wasHandled;
      });

      const addedCount = completeItems.length - dropped.length;
      if (addedCount > 0) {
        this.$store.dispatch('flashSuccess', `${addedCount} item(s) added to payment`);
      }
    },
    // New method to recalculate penalties for picklist payment dialog
    // Only recalculates for newly added records in the "Add Tax Details" section
    recalculatePenaltiesForPicklist(newPenaltyDate) {
      const { penaltyDate: settingPenaltyDate, penaltyRate } = this.taxSettingItem;

      // Get newly added tax details from the dialogTaxDetails component
      const newlyAddedDetails = this.newTaxDetailsToAdd || [];

      if (newlyAddedDetails.length === 0) {
        return;
      }

      // Check if any records are selected
      const selectedRecords = newlyAddedDetails.filter((item) => item.selected);

      // Recalculate penalties only for selected records (or all if none selected)
      const updatedNewDetails = newlyAddedDetails.map((item) => {
        // Check if this item should be processed
        const shouldProcess = selectedRecords.length === 0 || item.selected;

        // Skip if not in the processing list
        if (!shouldProcess) {
          return item;
        }

        // Skip if item is posted or doesn't have required data
        if (item.posted || !item.taxYear || !item.taxId) {
          return item;
        }

        const updatedItem = { ...item };
        const isExemptManufacturing = (item.statusCode || [])
          .includes(exemptManufacturingStatusCode);
        const isItAExemptPayment = updatedItem.isExempt;

        // Skip exempt payments
        if (isItAExemptPayment) {
          return item;
        }

        // Calculate penalty using the same logic as dialogTaxDetails
        const penaltyEndDate = toShortDate(newPenaltyDate);
        const penStartDate = toShortDate(item.penaltyStartDate);

        const returnedVal = penaltyCalculation(
          penaltyEndDate,
          penStartDate,
          settingPenaltyDate,
          amountToNumber(item.totalTax || item.taxAmt),
          amountToNumber(item.totalPaid || 0),
          0,
          penaltyRate,
          amountToNumber(item.totalDue || item.taxAmt),
          item.taxYear,
          (item.statusCode || []),
          this.taxSettingItem,
        );

        updatedItem.penaltyAmt = amountFormat(returnedVal.penaltyAmt);

        // Update feelist based on effective date if needed
        let totalFee = amountToNumber(item.totalFees) || 0;
        if ((item.allFeesList || []).length && !isExemptManufacturing) {
          const { feeDet, feesAmt } = getFeeListBasedOnEffeciveDate(
            item.allFeesList,
            newPenaltyDate,
          );
          totalFee = feesAmt;
          updatedItem.fees = feeDet;
          updatedItem.totalFees = amountFormat(totalFee);
        }

        // Update total amount
        const totalCalcAmt = amountToNumber(returnedVal.penaltyAmt)
          + amountToNumber(item.taxAmt)
          + amountToNumber(totalFee);
        updatedItem.total = amountFormat(totalCalcAmt || 0);

        return updatedItem;
      });

      // Update the newTaxDetailsToAdd array (v-model will sync to dialogTaxDetails)
      this.newTaxDetailsToAdd = updatedNewDetails;

      // Force recalculation of totals
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    openConfirmPopUp(cancleOrContinue) {
      if (cancleOrContinue === 'Cancel') {
        this.showOrHideWarningMessage = false;
        this.setIsVisible(['pickListMakePaymentDialog', false]);
      } else {
        this.showOrHideWarningMessage = false;
      }
    },
    handleCircleClass(textName) {
      if (textName === 'extraPayment' || textName === 'alreadyPayExits') return 'ChangeIconRedColor';
      if (textName === 'defaultText') return 'removeIcon';
      return 'ChangeIconYellowColor';
    },
  },
  created() {
    // Initialize pagination settings on component creation
    const paginationItem = {
      itemsperpage: this.getSettings.itemsperpage || 100,
      serverItemsLength: 0,
      footerProps: {
        'items-per-page-options': [10, 25, 50, 100, 200],
        'show-current-page': true,
        'show-first-last-page': true,
      },
    };
    this.setPaginationItems([this.baseCrudKey, paginationItem]);
    this.loadReasonCode({
      criteria: { sortBy: [{ column: 'reasonCode', direction: 'asc' }] },
      postProcessTrans: taxReasonListDropDownPostProcessTrans,
      baseCrudKey: 'reasonListDropDown',
    });
  },
  mounted() {
    // For picklist mode (no paymentNumber), initialize serverTotals
    // from existing editedItem.taxDetails
    // This ensures footer totals display correctly when dialog opens
    if (!this.paymentNumber && this.editedItem && this.editedItem.taxDetails) {
      const taxDetails = this.editedItem.taxDetails || [];
      const taxItems = taxDetails.filter(
        (item) => !item.taxType || item.taxType === 'TAXPAYMENT' || item.taxType === 'TAXREFUND',
      );

      if (taxItems.length > 0) {
        this.serverTotals = {
          totalTaxAmt: taxItems.reduce(
            (sum, item) => sum + amountToNumber(item.taxAmt), 0,
          ),
          totalDue: taxItems.reduce(
            (sum, item) => sum + amountToNumber(item.total), 0,
          ),
          totalPenalty: taxItems.reduce(
            (sum, item) => sum + amountToNumber(item.penaltyAmt), 0,
          ),
          totalFees: taxItems.reduce(
            (sum, item) => sum + amountToNumber(item.totalFees), 0,
          ),
          totalRecords: taxDetails.length,
        };

        // Update pagination with the record count
        const paginationItem = {
          itemsperpage: this.getSettings.itemsperpage || 100,
          serverItemsLength: this.serverTotals.totalRecords,
          footerProps: {
            'items-per-page-options': [10, 25, 50, 100, 200],
            'show-current-page': true,
            'show-first-last-page': true,
          },
        };
        this.setPaginationItems([this.baseCrudKey, paginationItem]);

        // Also set the items in the store for CRUDList to display
        this.setItems([this.baseCrudKey, taxDetails]);
      }
    }
  },
  beforeDestroy() {
    // cleanup store data on close / destroy, instead of when loading
    this.resetStoreData();
  },
  watch: {
    'paymentSettingItem.showCertNumberOnPaymentScreen': {
      handler(val) {
        this.headers = this.buildHeaders(val);
      },
      immediate: true,
    },
    // Watch for changes in newTaxDetailsToAdd and merge them to main list.
    //
    // This watcher and addToList() both commit staged rows, and they used to apply DIFFERENT
    // duplicate rules - this one checked both stores, addToList checked neither - so a row the
    // watcher had just committed could be appended a second time by an addToList fired in the
    // same tick (the Payment Info field activity and unpaids-loaded triggers both do). Both now
    // hand their rows to commitTaxRows, which owns the one rule.
    newTaxDetailsToAdd: {
      handler(newVal) {
        if (!newVal || newVal.length === 0) {
          return;
        }

        const currentItems = this.items(this.baseCrudKey) || [];

        // Only rows that resolved against tax inquiry: itsNewRecord is explicitly set to false
        // once the fetch succeeded, so anything still being typed is left staged.
        const completeNewItems = newVal.filter((newItem) => newItem.taxYear
          && newItem.taxId
          && newItem.ownerName
          && newItem.itsNewRecord === false);

        if (completeNewItems.length > 0) {
          this.commitTaxRows([...currentItems, ...completeNewItems], {
            addedItems: completeNewItems,
          });

          this.$nextTick(() => {
            this.$forceUpdate();
          });

          // Clear the handled rows out of the staging grid - added or rejected as duplicates
          // either way, they have had their turn.
          this.newTaxDetailsToAdd = newVal.filter((item) => {
            const wasHandled = completeNewItems.some((handledItem) => (
              String(handledItem.taxYear) === String(item.taxYear)
              && String(handledItem.taxId) === String(item.taxId)
            ));
            return !wasHandled;
          });
        }
      },
      deep: true,
    },
    fiscalYear: {
      handler(newVal) {
        if (newVal && this.paymentNumber) {
          this.loadLargePaymentData();
        }
      },
      immediate: true,
    },
    paymentNumber: {
      handler(newVal) {
        if (newVal && this.fiscalYear) {
          this.loadLargePaymentData();
        }
      },
      immediate: true,
    },
    // Watch for changes in calculated totals and emit to parent
    'calculatedTotals.total': {
      handler(newTotal) {
        // Emit the new total to parent component
        this.$emit('totalChanged', newTotal);
      },
    },
    // Watch for serverTotals changes and emit to parent
    serverTotals: {
      handler(newVal) {
        if (newVal && newVal.totalRecords > 0) {
          // Emit server totals to parent for accurate display across all pages
          this.$emit('serverTotalsChanged', {
            totalDue: newVal.totalDue,
            totalTaxAmt: newVal.totalTaxAmt,
            totalPenalty: newVal.totalPenalty,
            totalFees: newVal.totalFees,
            totalRecords: newVal.totalRecords,
          });
        }
      },
      deep: true,
      immediate: true,
    },
    // Watch for editedItem.taxDetails changes in picklist mode
    // This handles the case when taxDetails is populated after component mount
    'editedItem.taxDetails': {
      handler(newVal) {
        // Only for picklist mode (no paymentNumber) and when serverTotals not set
        const isPicklistMode = !this.paymentNumber;
        const hasData = newVal && newVal.length > 0;
        const totalsNotSet = this.serverTotals.totalRecords === 0;

        if (isPicklistMode && hasData && totalsNotSet) {
          const taxItems = newVal.filter(
            (item) => !item.taxType || item.taxType === 'TAXPAYMENT' || item.taxType === 'TAXREFUND',
          );

          if (taxItems.length > 0) {
            this.serverTotals = {
              totalTaxAmt: taxItems.reduce(
                (sum, item) => sum + amountToNumber(item.taxAmt), 0,
              ),
              totalDue: taxItems.reduce(
                (sum, item) => sum + amountToNumber(item.total), 0,
              ),
              totalPenalty: taxItems.reduce(
                (sum, item) => sum + amountToNumber(item.penaltyAmt), 0,
              ),
              totalFees: taxItems.reduce(
                (sum, item) => sum + amountToNumber(item.totalFees), 0,
              ),
              totalRecords: newVal.length,
            };

            // Update pagination with the record count
            const paginationItem = {
              itemsperpage: this.getSettings.itemsperpage || 100,
              serverItemsLength: this.serverTotals.totalRecords,
              footerProps: {
                'items-per-page-options': [10, 25, 50, 100, 200],
                'show-current-page': true,
                'show-first-last-page': true,
              },
            };
            this.setPaginationItems([this.baseCrudKey, paginationItem]);

            // Also set the items in the store for CRUDList to display
            this.setItems([this.baseCrudKey, newVal]);
          }
        }
      },
      immediate: true,
      deep: true,
    },
    // Update totals when props change
    totalDue: {
      handler() {
        // Force reactivity update for UI components that depend on totalDue
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    },
    totalPaid: {
      handler() {
        // Force reactivity update for UI components that depend on totalPaid
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    },
    cashChange: {
      handler() {
        // Force reactivity update for UI components that depend on cashChange
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      },
    },
  },
};

</script>
